import useEventListener from 'hooks/useEventListener'
import { isElementInViewport } from 'hooks/useInViewPort'
import { useRef, useEffect, useState } from 'react'

type UseCheckIsInViewProps = {
  canCheck: boolean
  onOpenChange: (value: boolean) => void
}

const useCheckIsInView = ({
  canCheck,
  onOpenChange,
}: UseCheckIsInViewProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const triggerRef = useRef<HTMLButtonElement>(null)

  const [isVisibleTrigger, setIsVisibleTrigger] = useState(true)
  const [isVisibleContentMenu, setIsVisibleContentMenu] = useState(true)

  const checkVisibility = () => {
    if (contentRef.current) {
      const isInViewport = isElementInViewport(contentRef.current)

      setIsVisibleContentMenu(isInViewport)
      !isInViewport && onOpenChange(false)
    }

    if (triggerRef.current)
      setIsVisibleTrigger(isElementInViewport(triggerRef.current))
  }

  useEventListener('scroll', checkVisibility)

  useEffect(() => {
    if (!canCheck) return

    // if the content menu is not visible, close the dropdown
    if (!isVisibleContentMenu) onOpenChange(false)
  }, [isVisibleContentMenu])

  const isVisible = isVisibleContentMenu || isVisibleTrigger

  return [isVisible, contentRef, triggerRef] as const
}

export default useCheckIsInView
